(function () {
    "use strict";
    const HTTP_STATUS_CODE_UNAUTHORIZED = 401;
    const HTTP_STATUS_CODE_FORBIDDEN = 403;

    /**
     * Registers an interceptor which detects expired sessions.
     * When this happens, redirect to the login page.
     */
    angular.module('app').factory('unauthorizedAccess', UnauthorizedAccessInterceptor);

    UnauthorizedAccessInterceptor.$inject = ['$rootScope', '$q', 'HabilNavigator'];
    function UnauthorizedAccessInterceptor($rootScope, $q, HabilNavigator) {
        return {
            responseError: responseError
        };

        function responseError(response) {
            if (response.status === HTTP_STATUS_CODE_UNAUTHORIZED) {
                HabilNavigator.OpenRoute('Account/Login');
                return;
            }

            $rootScope.accessDenied = response.status === HTTP_STATUS_CODE_FORBIDDEN;

            // Return rejected promise to ensure that the errorCallback is triggered
            return $q.reject(response);
        }
    }
})();